import { render, staticRenderFns } from "./SMTP.vue?vue&type=template&id=6663a3c9&"
import script from "./SMTP.vue?vue&type=script&lang=js&"
export * from "./SMTP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports